import implants from "./dental-implants";
import rct from "./root-canal-treatment";
import teethCleaning from "./teeth-cleaning";
import dentalFillings from "./dental-fillings";
import dentures from "./dentures";
import bracesAligners from "./braces-aligners";
import wisdomToothRemoval from "./wisdom-tooth-removal";
import dentalCrownsBridges from "./dental-crowns-bridges";
import dentalExtractions from "./dental-extractions";
import teethWhitening from "./teeth-whitening";
import kidsDentistry from "./kids-dentistry";
import gumTreatment from "./gum-treatment";
import smileDesigning from "./smile-designing";

export default [implants, rct, teethCleaning, dentalFillings, dentures, bracesAligners, wisdomToothRemoval, dentalCrownsBridges, dentalExtractions, teethWhitening, kidsDentistry, gumTreatment, smileDesigning];